<template>
<div class="chapter">
<div class="inner_page">
<p class="h1"><i>Acknowledgements</i></p>
<p class="noindent">Thank you to Sharon Stackhouse and Robynn Thomas, descendents of Joseph Walker, who shared their research, photographs and insights with me about the Walker case. Thanks also to their parents, Robert Tunstall Walker Jr. and Janet Robinson Walker, for sharing their family papers and photographs. I deeply admire the family’s efforts to gain proper recognition for their ancestor’s sacrifice. I also owe thanks to Julie Pickett, cofounder of Friends of the Animas City Cemetery, for sharing her considerable knowledge of the Stockton brothers and for sending me her shot of Isaac “Ike” Stockton’s grave in that cemetery. A big thank-you goes to Ron Moore and the folks at Durango’s Greenmount Cemetery for allowing me to use a number of photographs from their excellent website. Thanks also to Lindsay Eppich, for her photographs (and for digging through the snow); to Richard Turner, for his fine drawings; and to John and Lynn Turner and Jolie Gallagher, for feedback on the manuscript. Thanks to Elena Cline at the Colorado State Archives for her help with the mug shots and to the wonderful folks who run the Colorado Historic Newspapers Collection. Finally, many thanks go to Becky LeJeune, acquisitions editor at The History Press, who is a joy to work with.</p>
<p class="indent">Photos from the Walker family collection are courtesy of Robert Tunstall Walker Jr., Janet Robinson Walker, Sharon Stackhouse and Robynn Thomas.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgement.vue?fa4ebb4e